export default __webpack_public_path__ + "static/media/scan_complete.2db0f116.png";